import React from 'react';
import { Box } from '@mui/material';

// Pill-style CTA used across inner pages so they share the same
// vocabulary as the homepage hero buttons.
export default function EditorialButton({
  variant = 'primary',
  onClick,
  href,
  target,
  rel,
  type = 'button',
  disabled = false,
  fullWidth = false,
  sx,
  children,
}) {
  const isInverse = variant === 'inverse';
  const isGhost = variant === 'ghost';
  const isSecondary = variant === 'secondary';

  const base = {
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    px: 3.5,
    py: 1.6,
    border: '1.5px solid transparent',
    fontFamily: 'var(--font-body)',
    fontWeight: 700,
    fontSize: 12.5,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    borderRadius: 999,
    width: fullWidth ? '100%' : 'auto',
    transition: 'background 250ms ease, color 250ms ease, border-color 250ms ease, transform 250ms ease',
  };

  let variantSx = {};
  if (isGhost) {
    variantSx = {
      background: 'transparent',
      color: 'var(--navy-500)',
      borderColor: 'var(--navy-500)',
      '&:hover': { background: 'var(--navy-500)', color: '#fff' },
    };
  } else if (isInverse) {
    variantSx = {
      background: 'transparent',
      color: '#fff',
      borderColor: 'rgba(255,255,255,0.6)',
      '&:hover': { background: '#fff', color: 'var(--navy-500)', borderColor: '#fff' },
    };
  } else if (isSecondary) {
    variantSx = {
      background: 'var(--navy-500)',
      color: '#fff',
      borderColor: 'var(--navy-500)',
      '&:hover': { background: 'var(--navy-700)', borderColor: 'var(--navy-700)', transform: 'translateY(-2px)' },
    };
  } else {
    variantSx = {
      background: 'var(--teal-500)',
      color: '#fff',
      borderColor: 'var(--teal-500)',
      '&:hover': { background: 'var(--teal-700)', borderColor: 'var(--teal-700)', transform: 'translateY(-2px)' },
    };
  }

  const Component = href ? 'a' : 'button';
  return (
    <Box
      component={Component}
      href={href}
      target={href ? target : undefined}
      rel={href ? rel : undefined}
      type={!href ? type : undefined}
      onClick={onClick}
      disabled={!href ? disabled : undefined}
      sx={{ ...base, ...variantSx, ...sx }}
    >
      {children}
    </Box>
  );
}
